import {
  apiErrorMapper,
  initialBrandExclusionsViewModel,
  saveCampaignAndLinkedData,
} from '@bingads-webui-campaign-react/perf-max-step-wizard';
import { notificationApi } from '@bingads-webui-campaign/notification-center';
import { getRoutePathById, allSiteMap } from '@bingads-webui-campaign-react/with-site-map';
import { getDefaultCampaignData } from './default-data';

export const createDefaultCampaign = ({
  i18n,
  serverContext,
  scenarioContext,
  providerId = '',
  salesCountry = undefined,
  localInventory = false,
  isFeedFiltered = false,
  feedLabel = null,
}) => {
  const permissions = serverContext.Permissions || {};

  const initialCampaignViewModel = {
    data: getDefaultCampaignData({
      i18n,
      serverContext,
      providerId,
      salesCountry,
      localInventory,
      isFeedFiltered,
      feedLabel,
      cnMarketAccount: permissions.IsDomesticSimplifiedChineseEnabled,
    }),
  };

  return saveCampaignAndLinkedData({
    campaign: initialCampaignViewModel,
    originalCampaign: {},
    brandExclusions: initialBrandExclusionsViewModel,
  }, {
    scenario: scenarioContext.name,
    i18n,
    activityLogger: scenarioContext.createActivity('saveDefaultCampaign'),
  });
};

export const handleDefaultCampaignCreationError = ({
  i18n,
  scope,
  errorData,
}) => {
  // Only server errors are avaialble at this point
  const { serverErrors = [] } = errorData || {};
  const errorMessages = serverErrors.map(apiErrorMapper).join(', ');
  notificationApi.showWarning(i18n.getString(_TL_("We've encountered errors - {{errorMessages}} and can't continue. Please contact support for further assistance."), { errorMessages }));

  const campaignsPagePath = getRoutePathById(allSiteMap, 'campaigns');
  const { aid, cid, uid } = scope.values;
  const searchParams = `?uid=${uid}&cid=${cid}&aid=${aid}`;
  scope.history.push({
    pathname: campaignsPagePath,
    search: searchParams,
  });
};
